import { t } from '@/i18n';
import { Th, Thead, Tr } from '@chakra-ui/react';

export const labels = [
  { label: t('pages.application_calendar_week.components.week_schedule_header.weekday') },
  { label: t('pages.application_calendar_week.components.week_schedule_header.description') },
  { label: t('pages.application_calendar_week.components.week_schedule_header.actions'), centered: true },
];

export const ApplicationCalendarWeekScheduleHeader = () => {
  return (
    <Thead
      sx={{
        '& th': {
          py: '8px',
        },
      }}
    >
      <Tr>
        {labels.map(({ label, centered }) => (
          <Th key={label} textAlign={centered ? 'center' : 'initial'}>
            {label?.toUpperCase()}
          </Th>
        ))}
      </Tr>
    </Thead>
  );
};
